import { Box, Button, CircularProgress } from "@mui/material";
import React, { Suspense } from "react";
import { Await, defer, Link, useLoaderData } from "react-router-dom";
import { getSystemMailCampaigns } from "../../api/systemMailCampaignClient";
import SystemMailCampaignTable from "../../components/SystemMailCampaign/SystemMailCampaignTable";
import { SystemMailCampaign } from "../../model/SystemMailCampaign";
import classes from "../../styling/pages/Manager.module.css";
import { useTranslation } from "react-i18next";

const SystemMailCampaignManagerPage: React.FC = () => {
    const { t } = useTranslation();
    const { campaigns } = useLoaderData() as { campaigns: Promise<SystemMailCampaign[]> };

    return (
        <>
            <Box className={classes.buttonContainer}>
                <Link to="new">
                    <Button variant="contained">
                        {t("systemMailCampaign.manager.newCampaign")}
                    </Button>
                </Link>
            </Box>
            <Suspense fallback={<CircularProgress />}>
                <Await resolve={campaigns}>
                    {(loadedCampaigns) => (
                        <SystemMailCampaignTable campaigns={loadedCampaigns} />
                    )}
                </Await>
            </Suspense>
        </>
    );
};

export default SystemMailCampaignManagerPage;

async function loadCustomerSystemMailCampaigns(customerId: string) {
    return getSystemMailCampaigns(customerId);
}

export async function loader({
    params,
}: {
    request: Request;
    params: { customerId: string };
}) {
    const customerId = params.customerId;
    return defer({
        campaigns: loadCustomerSystemMailCampaigns(customerId),
    });
}
